import React from 'react';
import { AutocompleteInput, ReferenceInput } from 'react-admin';
import { useFormState } from 'react-final-form';

const CustomLevelInput = (props: any) => {
    const { values } = useFormState();

    return (
        <ReferenceInput
            label="Select Level"
            source="levelId"
            reference="levels"
            filter={{ SchoolId: Number(values.level?.schoolId) }}
            disabled
        >
            <AutocompleteInput optionText="name" />
        </ReferenceInput>
    );
};

export default CustomLevelInput;